var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-v2-badges"},[_c('div',{staticClass:"home-v2-badges__inner"},_vm._l((_vm.block.badges),function(badge){return _c('div',{key:badge.id,staticClass:"home-v2-badges__badge",class:{
        'home-v2-badges__badge--vertical':
          badge.image.image.height > badge.image.image.width,
      }},[_c('a',{attrs:{"href":badge.url,"target":"_blank"}},[(badge.image)?_c('img',{attrs:{"src":badge.image.image.src,"alt":badge.image.image.alt,"srcset":`${badge.image.retina_image.src} 2x`,"loading":"lazy"}}):_vm._e()])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }